import axiosInstance from "../utils/axiosInstance"
import { API_ENDPOINTS } from "../constants/config"

// Super Admin
export const fetchPlans = (params = {}) =>
  axiosInstance.get(API_ENDPOINTS.billingPlans, { params }).then((r) => r.data)

export const createPlan = (data) =>
  axiosInstance.post(API_ENDPOINTS.billingPlans, data).then((r) => r.data)

export const updatePlan = (planId, data) =>
  axiosInstance.put(API_ENDPOINTS.billingPlan(planId), data).then((r) => r.data)

export const disablePlan = (planId, reason) =>
  axiosInstance.post(API_ENDPOINTS.billingPlanDisable(planId), { reason }).then((r) => r.data)

export const fetchSubscriptionHistory = (schoolId) =>
  axiosInstance.get(API_ENDPOINTS.billingSubscriptions(schoolId)).then((r) => r.data)

export const grantTrial = (schoolId, data) =>
  axiosInstance.post(API_ENDPOINTS.billingSubscriptionTrial(schoolId), data).then((r) => r.data)

export const changeUserLimit = (schoolId, data) =>
  axiosInstance.post(API_ENDPOINTS.billingSubscriptionUserLimit(schoolId), data).then((r) => r.data)

export const editTrialEndDate = (schoolId, data) =>
  axiosInstance.post(API_ENDPOINTS.billingSubscriptionTrialEndDate(schoolId), data).then((r) => r.data)

export const fetchPayments = (schoolId) =>
  axiosInstance.get(API_ENDPOINTS.billingPayments(schoolId)).then((r) => r.data)

export const recordManualPayment = (schoolId, data) =>
  axiosInstance.post(API_ENDPOINTS.billingPaymentsManual(schoolId), data).then((r) => r.data)

export const fetchInvoices = (schoolId) =>
  axiosInstance.get(API_ENDPOINTS.billingInvoices(schoolId)).then((r) => r.data)

export const fetchEntitlement = (schoolId) =>
  axiosInstance.get(API_ENDPOINTS.billingEntitlement(schoolId)).then((r) => r.data)

export const fetchAuditLog = (schoolId) =>
  axiosInstance.get(API_ENDPOINTS.billingAuditLog(schoolId)).then((r) => r.data)

export const fetchRefunds = (schoolId) =>
  axiosInstance.get(API_ENDPOINTS.billingRefunds(schoolId)).then((r) => r.data)

export const createRefund = (schoolId, paymentId, data) =>
  axiosInstance.post(API_ENDPOINTS.billingPaymentRefund(schoolId, paymentId), data).then((r) => r.data)

export const fetchDiscounts = (schoolId) =>
  axiosInstance.get(API_ENDPOINTS.billingDiscounts(schoolId)).then((r) => r.data)

export const setDiscount = (schoolId, data) =>
  axiosInstance.post(API_ENDPOINTS.billingDiscounts(schoolId), data).then((r) => r.data)

export const removeDiscount = (schoolId, planId) =>
  axiosInstance.delete(API_ENDPOINTS.billingDiscountRemove(schoolId, planId)).then((r) => r.data)

// Tenant self-service
export const fetchMyBillingOverview = () =>
  axiosInstance.get(API_ENDPOINTS.billingMyOverview).then((r) => r.data)

export const fetchMyPayments = () =>
  axiosInstance.get(API_ENDPOINTS.billingMyPayments).then((r) => r.data)

export const fetchMyPlans = () =>
  axiosInstance.get(API_ENDPOINTS.billingMyPlans).then((r) => r.data)

export const fetchMyInvoices = () =>
  axiosInstance.get(API_ENDPOINTS.billingMyInvoices).then((r) => r.data)

export const createMyOrder = (data) =>
  axiosInstance.post(API_ENDPOINTS.billingMyOrders, data).then((r) => r.data)

export const markMyNudgeShown = () =>
  axiosInstance.post(API_ENDPOINTS.billingMyNudgeShown).then((r) => r.data)

export const fetchMyAccessStatus = () =>
  axiosInstance.get(API_ENDPOINTS.billingMyAccessStatus).then((r) => r.data)
